"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLanguages = exports.Catalogs = exports.Countries = exports.Languages = void 0;
var Languages;
(function (Languages) {
    Languages["CHINESE_SIMPLIFIED"] = "zh";
    Languages["ENGLISH"] = "en";
    Languages["FRENCH"] = "fr";
    Languages["GERMAN"] = "de";
    Languages["ITALIAN"] = "it";
    Languages["PORTUGUESE"] = "pt";
    Languages["RUSSIAN"] = "ru";
    Languages["SPANISH"] = "es";
    Languages["CHINESE"] = "cn";
    Languages["DUTCH"] = "nl";
})(Languages || (exports.Languages = Languages = {}));
var Countries;
(function (Countries) {
    Countries["BRAZIL"] = "BR";
    Countries["CHINA"] = "CN";
    Countries["FRANCE"] = "FR";
    Countries["GERMANY"] = "DE";
    Countries["ITALY"] = "IT";
    Countries["PORTUGAL"] = "PT";
    Countries["RUSSIA"] = "RU";
    Countries["SPAIN"] = "ES";
    Countries["UNITED_KINGDOM"] = "GB";
    Countries["UNITED_STATES"] = "US";
    Countries["NETHERLAND"] = "NL";
})(Countries || (exports.Countries = Countries = {}));
var Catalogs;
(function (Catalogs) {
    Catalogs["WORLDWIDE"] = "worldwide";
    Catalogs["USA"] = "usa";
    Catalogs["BRAZILIAN"] = "brazilian";
    Catalogs["CHINESE"] = "chinese";
})(Catalogs || (exports.Catalogs = Catalogs = {}));
var DefaultLanguages;
(function (DefaultLanguages) {
    DefaultLanguages["DEFAULT"] = "default";
    DefaultLanguages["X_DEFAULT"] = "x-default";
})(DefaultLanguages || (exports.DefaultLanguages = DefaultLanguages = {}));
//# sourceMappingURL=languages.js.map